import { WebSocketLink } from '@apollo/client/link/ws'

const createWebsocketLink = (subscriptionUri, getAccessToken) =>
  new WebSocketLink({
    uri: subscriptionUri,
    options: {
      reconnect: true,
      connectionParams: () => ({
        accessToken: getAccessToken(),
      }),
    },
  })

export default createWebsocketLink
